var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("AccountManagement.staffLeave.records"),
        visible: _vm.visible,
        width: "95%",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm.loadFailed
        ? _c("el-alert", {
            attrs: {
              title: _vm.$t("AccountManagement.staffLeave.loadFailed"),
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "leave-table",
          attrs: {
            data: _vm.pageRecords,
            border: "",
            stripe: "",
            "max-height": "560",
            "empty-text": _vm.$t("AccountManagement.staffLeave.empty"),
          },
        },
        _vm._l(_vm.columns, function (column) {
          return _c("el-table-column", {
            key: column.prop,
            attrs: {
              prop: column.prop,
              label: _vm.$t("AccountManagement.staffLeave." + column.prop),
              "min-width": column.weight,
            },
          })
        }),
        1
      ),
      _c("el-pagination", {
        staticClass: "leave-pagination",
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [20, 50, 100],
          total: _vm.records.length,
          layout: "total, sizes, prev, pager, next",
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.page = $event
          },
          "update:current-page": function ($event) {
            _vm.page = $event
          },
          "size-change": _vm.changePageSize,
        },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading },
              on: { click: _vm.fetchRecords },
            },
            [_vm._v(_vm._s(_vm.$t("AccountManagement.staffLeave.refresh")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("AccountManagement.work.close")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }